import { ONBOARDING_REQUIRED_AFTER, ONBOARDING_ADMIN_ROLES } from '@/constants/onboarding';

/**
 * Whether the full-screen intake wizard should be shown.
 */
export function needsOnboardingIntake(organization, role) {
  if (!organization || !role) return false;
  if (!ONBOARDING_ADMIN_ROLES.includes(role)) return false;

  const onboarding = organization.settings?.onboarding || {};
  if (onboarding.disabled) return false;
  if (onboarding.intake_completed_at) return false;
  if (onboarding.required) return true;

  if (!organization.created_at) return false;
  return new Date(organization.created_at) >= new Date(ONBOARDING_REQUIRED_AFTER);
}

function hasIncompleteChecklistSteps(progress = {}) {
  return !(
    progress.profile_complete &&
    progress.team_complete &&
    progress.products_complete &&
    progress.form_published
  );
}

/**
 * Whether the org still has open checklist steps (persistent banner).
 */
export function needsOnboardingChecklist(organization, role, progress = {}) {
  if (!organization || !role) return false;
  if (!ONBOARDING_ADMIN_ROLES.includes(role)) return false;

  const onboarding = organization.settings?.onboarding || {};
  if (onboarding.disabled) return false;
  if (!onboarding.intake_completed_at) return false;

  return hasIncompleteChecklistSteps(progress);
}

/**
 * Whether the checklist modal should auto-open (not dismissed yet).
 */
export function shouldAutoShowChecklist(organization, role, progress = {}) {
  if (!needsOnboardingChecklist(organization, role, progress)) return false;

  const onboarding = organization.settings?.onboarding || {};
  return !onboarding.checklist_dismissed_at;
}

export function getOnboardingRedirectPath(organization, role) {
  if (needsOnboardingIntake(organization, role)) {
    return '/onboarding';
  }
  return null;
}
